/**
 * 長距離配車の右カラム幅のうち、この画面だけの値（既定幅と localStorage キー）。
 * 上下限・clamp・器への収め方は共有の components/dispatch/panelResize/panelWidth.ts。
 *
 * log_web_issues#338 C3。/map (#299)・カード配車 (#312) で入れた幅可変をこの画面にも広げる。
 * 右のパネルは 3 画面とも同じ `ConvenienceDispatchUnassignedList` なので、
 * 上下限 260〜720px はそのまま通用する。
 *
 * Why キーを他画面と分ける: 既定幅が違う（/map は 340・カード配車と長距離は 380）ので、
 * 共有するとどれかの初回表示が変わる。中央に置くものも地図・カードボード・日付ボードで
 * 違うため、ちょうどよい右の幅も画面ごとに変わる。
 *
 * Why 左カラムは可変にしない: 左は既存の車両リストを 1 レーン 1 行で流用していて、
 * 中央のレーンと高さも幅の前提も揃えてある（`layout.ts`）。依頼（C3）も右カラムだけを
 * 対象にしている。
 */

/** 既定は変更前の固定値そのまま。初回表示の見た目を変えない */
export const DEFAULT_UNASSIGNED_PANEL_WIDTH = 380;

export const UNASSIGNED_PANEL_WIDTH_STORAGE_KEY = 'longHaul.rightPanelWidth';
